import {Component, OnInit} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {Applicant} from '../../models/applicant';
import {AssessorSelfRegistrationRequest} from '../../models/assessorSelfRegistrationRequest';
import {AuthenticationStorageService} from '../../services/authentication-storage.service';
import {environment} from '../../../../../environments/environment';
import {CaptchaService} from '../../services/captcha.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-assessor-registration',
  templateUrl: './assessor-registration.component.html',
  styleUrls: ['./assessor-registration.component.scss'],
})
export class AssessorRegistrationComponent implements OnInit {
  assessorRegForm: FormGroup;
  otpForm!: FormGroup;

  assessor!: Applicant;
  selfRegistrationRequest!: AssessorSelfRegistrationRequest;
  regex = /[a-zA-Z]*/;
  nameRegex = /^(?=.*[A-Za-z])[A-Za-z0-9. ]+$/;

  tempNumber = 0;
  validateForm!: FormGroup;
  contactNumber!: string;
  receivedOtp!: string;
  nzFooterVisible = false;
  emailAlreadyExist = false;
  nameAlreadyExist = false;

  nidAlreadyExist = false;

  passwordVisible = false;
  confirmPasswordVisible = false;
  stpNameAlredyExist = false;
  captchaError: boolean = false;
  captchaText: string;
  userInput: any;
  //userForm: FormGroup;
  isVisible = false;
  timelimit = 300;
  showResendOTP: boolean = false;
  otpIsLoading: boolean = false;
  alreadySmsSend: boolean = false;
  submitOtpToMobile: boolean = false;
  private countdown!: number;
  private timerInterval!: any;
  timerText: string = '5:00';
  display: string = '05:00'; // Initial display (5 minutes)

  ngOnInit() {
    this.captchaText = this.captchaService.captchaGenerator();
    this.assessorRegForm.controls.email.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value: string) => {
        this.checkEmailExist(value);
      });
  }

  // Otp section ends

  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private authStorageService: AuthenticationStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private captchaService: CaptchaService,
  ) {
    this.assessorRegForm = this.fb.group({
      name: [
        '',
        [
          Validators.required,
          Validators.pattern(this.nameRegex),
          this.noWhitespaceValidator,
        ],
      ],
      nid: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(01)?(\d{10}|\d{13}|\d{17})$/),
        ],
      ],
      email: [null, [Validators.email, Validators.required]],
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#$!%?&^*;:,<>.`~-])[A-Za-z\d$@#$!%?&^*;:,<>.`~-]{8,}$/,
          ),
        ],
      ],
      confirmPassword: ['', [this.confirmValidator]],
      contactNumberPrefix: ['+880'],
      contactNumber: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern(/^1[3-9][0-9]{8}$/),
        ],
      ],
      captcha: new FormControl('', Validators.required),
    });
    this.otpForm = this.fb.group({
      otp: [
        '',
        [Validators.required, Validators.pattern(/^(?:\01)?(?:\d{5})$/)],
      ],
    });
    //this.timer(5);
  }

  refreshCaptcha() {
    this.captchaText = this.captchaService.captchaGenerator();
    this.captchaError = false;
  }

  verify() {
    if (this.userInput === this.captchaText) {
      this.submitForm();
    } else {
      this.notification.error('Invalid!', 'Please correct the CAPTCHA!');
      this.captchaError = true;
    }
  }

  submitForm(): void {
    for (const key of Object.keys(this.assessorRegForm.controls)) {
      this.assessorRegForm.controls[key].markAsDirty();
      this.assessorRegForm.controls[key].updateValueAndValidity();
    }
    this.refreshCaptcha();
    this.startCountdown(this.timelimit);
    this.sendOtpTouser();
    this.showModal();
  }

  submitOtp(): void {
    this.receivedOtp = this.otpForm.get('otp')?.value;

    const selfRegistrationRequest = new AssessorSelfRegistrationRequest();

    selfRegistrationRequest.email = this.assessorRegForm.controls.email.value;

    selfRegistrationRequest.contactNumber =
      this.assessorRegForm.controls.contactNumber.value;

    selfRegistrationRequest.contactNumberPrefix =
      this.assessorRegForm.controls.contactNumberPrefix.value;

    selfRegistrationRequest.name = this.assessorRegForm.controls.name.value;

    selfRegistrationRequest.password =
      this.assessorRegForm.controls.confirmPassword.value;

    selfRegistrationRequest.nid = this.assessorRegForm.controls.nid.value;

    //selfRegistrationRequest.role = 'Applicant';
    selfRegistrationRequest.role = 'Assessor, Applicant';

    // selfRegistrationRequest.designation = this.assessorRegForm.controls.stpDesignation.value;

    this.authStorageService
      .getVerifiedOtp(this.receivedOtp, this.contactNumber)
      .subscribe({
        next: (response) => {
          this.authStorageService
            .createAssessor(selfRegistrationRequest)
            .subscribe({
              next: (serverResponse) => {
                this.selfRegistrationRequest = serverResponse.data;
                // const applicant = new Applicant();

                // applicant.userId = this.selfRegistrationRequest.id;

                // applicant.nid =
                //   this.assessorRegForm.controls.nid.value;

                // applicant.name =
                //   this.assessorRegForm.controls.name.value;

                // applicant.applicantEmail =
                //   this.assessorRegForm.controls.email.value;

                // applicant.applicantMobileNo =
                //   this.assessorRegForm.controls.mobileNo.value;

                // this.saveApplicantProfile(applicant);

                this.assessorRegForm.reset();
                const returnUrl =
                  this.route.snapshot.queryParams.returnUrl || '/login';
                this.router.navigateByUrl(returnUrl);
                this.notification.success(
                  'Success!',
                  'Please check your email for validation',
                );
                this.isVisible = false;
              },

              error: (error) => {
                this.notification.error(error, error.message);
              },
            });
        },
        error: (error) => this.notification.error('Failed', 'OTP is not valid'),
      });
    this.otpForm.reset();

    // this.validateForm.reset();
  }

  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return {error: true, required: true};
    } else if (control.value !== this.assessorRegForm.controls.password.value) {
      return {confirm: true, error: true};
    }
    return {};
  };

  // checkEmailExist(email: any): void {
  //   this.emailAlredyExist = false;
  //   setTimeout(() => {
  //     if (email.value.length > 3) {
  //       this.authStorageService
  //         .checkApplicantEmailExist(email.value)
  //         .subscribe({
  //           next: (res) => {
  //             if (res.data == null) {
  //               this.emailAlredyExist = false;
  //             } else {
  //               this.emailAlredyExist = true;
  //               this.assessorRegForm.controls.email.setErrors({
  //                 incorrect: true,
  //               });
  //             }
  //           },
  //         });
  //     }
  //   }, 2000);
  // }

  checkEmailExist(value: string): void {
    this.emailAlreadyExist = false;

    if (!value || value.length < 4) {
      return;
    }

    const email = value.trim().toLowerCase();

    this.authStorageService.checkApplicantEmailExist(email).subscribe({
      next: (res) => {
        const control = this.assessorRegForm.controls.email;

        if (res.data) {
          this.emailAlreadyExist = true;
          control.setErrors({
            ...control.errors,
            emailExists: true,
          });
        } else {
          this.emailAlreadyExist = false;

          if (control.hasError('emailExists')) {
            const errors = {...control.errors};
            delete errors['emailExists'];
            control.setErrors(Object.keys(errors).length ? errors : null);
          }
        }
      },
    });
  }

  checkNameExist(name: any): void {
    this.nameAlreadyExist = false;
    setTimeout(() => {
      if (name.value.length > 3) {
        this.authStorageService.checkApplicantEmailExist(name.value).subscribe({
          next: (res) => {
            if (res.data == null) {
              this.nameAlreadyExist = false;
            } else {
              this.nameAlreadyExist = true;
              this.assessorRegForm.controls.name.setErrors({
                incorrect: true,
              });
            }
          },
        });
      }
    }, 2000);
  }

  validateConfirmPassword(): void {
    setTimeout(() =>
      this.assessorRegForm.controls.confirmPassword.updateValueAndValidity(),
    );
  }

  nidValidation(control: AbstractControl) {
    if (control.value.length <= 10) {
      return {error: true, required: true};
    } else if (control.value.length <= 17) {
      return {error: true, required: true};
    }
    return {};
  }

  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.assessorRegForm.reset();
    this.assessorRegForm.get('contactNumberPrefix')?.setValue('+880');

    for (const key of Object.keys(this.assessorRegForm.controls)) {
      this.assessorRegForm.controls[key].markAsPristine();
      this.assessorRegForm.controls[key].updateValueAndValidity();
    }
  }

  saveApplicantProfile(applicant: Applicant): void {
    this.authStorageService.createApplicantUser(applicant).subscribe({
      next: (serverResponse) => {
        this.assessorRegForm.reset();
        const returnUrl = this.route.snapshot.queryParams.returnUrl || '/login';
        this.router.navigateByUrl(returnUrl);
        this.notification.success(
          'Success!',
          'Please check your email for validation',
        );
      },
      error: (error) => {
        this.notification.error(error, error.message);
      },
    });
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {whitespace: true};
  }

  //#region OTP

  sendOtpTouser(): void {
    this.isVisible = false;
    this.contactNumber = '0' + this.assessorRegForm.get('contactNumber')?.value;
    this.authStorageService.getOtp(this.contactNumber).subscribe({
      next: (res) => {
        if (res.success == true) {
          this.notification.success('Success!', res.message);
          this.isVisible = true;
        } else {
          this.notification.error('Failed!', res.message);
          this.isVisible = false;
        }
      },
      error: (error) =>
        this.notification.error(
          'Failed',
          'OTP is not Send, Please try again later',
        ),
    });
    // this.isVisible = true;
    //  this.nzFooter = false;
    setTimeout(() => {
      this.isVisible = false;
    }, 300000);
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  /*timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);
  }*/

  // checkNidExist(nid: any): void {
  //   this.nidAlredyExist = false;
  //   setTimeout(() => {
  //     if (nid.value.length > 9) {
  //       this.authStorageService.checkApplicantNidExist(nid.value).subscribe({
  //         next: (res) => {
  //           if (res.data == null) {
  //             this.nidAlredyExist = false;
  //           } else {
  //             this.nidAlredyExist = true;
  //             this.assessorRegForm.controls.nid.setErrors({
  //               incorrect: true,
  //             });
  //           }
  //         },
  //       });
  //     }
  //   }, 2000);
  // }

  nidTimeout: any; // declare at class level

  onNidInput(nid: any): void {
    const digitsOnly = nid.value.replace(/\D/g, '');
    if (digitsOnly !== nid.value) {
      this.assessorRegForm.controls.nid.setValue(digitsOnly);
    }
  }

  checkNidExist(nid: any): void {
    this.nidAlreadyExist = false;

    clearTimeout(this.nidTimeout);

    this.nidTimeout = setTimeout(() => {
      const value = nid?.value;
      const control = this.assessorRegForm.controls.nid;

      if (value?.length === 10 || value?.length === 13 || value?.length === 17) {
        this.authStorageService.checkAssessorNidExist(value).subscribe({
          next: (res) => {
            if (res.data === false) {
              this.nidAlreadyExist = false;

              if (control.hasError('incorrect')) {
                const errors = { ...control.errors };
                delete errors['incorrect'];
                control.setErrors(Object.keys(errors).length ? errors : null);
              }
            } else {
              this.nidAlreadyExist = true;
              control.setErrors({
                ...control.errors,
                incorrect: true,
              });
            }
          },
          error: () => {
            this.nidAlreadyExist = false;
          },
        });
      } else {
        this.nidAlreadyExist = false;

        if (control.hasError('incorrect')) {
          const errors = { ...control.errors };
          delete errors['incorrect'];
          control.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }, 500); // reduced delay for better UX
  }

  startCountdown(durationInSeconds: number) {
    this.countdown = durationInSeconds;

    this.timerInterval = setInterval(() => {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      this.timerText = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      if (this.countdown <= 0) {
        this.resetCountdown();
        //this.isVisible=false;
      } else {
        this.countdown--;
      }

      if (this.countdown === 0) {
        //alert("Reset OTP function call")
        this.showResendOTP = true;
        this.alreadySmsSend = false;
        //this.timerSub.unsubscribe();
      }
    }, 1000);
  }

  resetCountdown() {
    clearInterval(this.timerInterval);
    this.timerText = '5:00'; // Reset UI
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }

  resendOTP(): void {
    this.otpIsLoading = true;
    if (!this.assessorRegForm.valid) {
      Object.keys(this.assessorRegForm.controls).forEach((key) => {
        this.assessorRegForm.controls[key].markAsDirty();
        this.assessorRegForm.controls[key].updateValueAndValidity();
      });
      this.otpIsLoading = false;
      return;
    }

    const mobileControl = this.assessorRegForm.controls['contactNumber'];
    this.authStorageService.getOtp('0' + mobileControl.value).subscribe({
      next: () => {
        console.log('OTP sent successfully');
        this.notification.success(
          'OTP Sent',
          'An OTP has been sent to your phone number.',
        );
        this.submitOtpToMobile = true;
        this.startCountdown(this.timelimit);
        this.showModal();
        this.otpIsLoading = false;
        this.alreadySmsSend = true;
      },
      error: () => {
        this.notification.error(
          'Failed',
          'Failed to send OTP, please try again.',
        );
        this.otpIsLoading = false;
      },
    });
  }
}
